import { useState } from "react";
import { PageHeader } from "../molecules/PageHeader";
import { StatsGrid } from "../organisms/StatsGrid";
import { DataTable } from "../organisms/DataTable";
import { FilterButton } from "../atoms/FilterButton";
import { More } from "iconsax-react";

import {
  SUPPORT_STATS,
  MOCK_SUPPORT_TICKETS,
  MOCK_USER_FEEDBACKS,
  MOCK_EMAIL_FEEDBACKS,
  type SupportTicket,
  type UserFeedback,
  type EmailFeedback,
  SUPPORTTICKET_TABLE_HEADERS,
  USERFEEDBACK_TABLE_HEADERS,
  EMAILFEEDBACK_TABLE_HEADERS,
} from "@/data/support.data";

const SupportTicketTableRow = ({ ticket }: { ticket: SupportTicket }) => (
  <tr className="border-b border-dark-30 hover:bg-dark-30 transition-colors">
    <td className="px-6 py-4 text-dark-text font-medium">{ticket.ticketID}</td>
    <td className="px-6 py-4 text-dark-text">{ticket.user}</td>
    <td className="px-6 py-4 text-dark-text">{ticket.category}</td>
    <td className="px-6 py-4 text-dark-text">{ticket.assignedTo}</td>
    <td className="px-6 py-4 text-dark-text">{ticket.priority}</td>
    <td className="px-6 py-4 text-dark-text">{ticket.dateReported}</td>
    <td className="px-6 py-4">
      <span className="inline-flex px-2 py-1 rounded text-sm text-dark-text">
        {ticket.status}
      </span>
    </td>
    <td className="px-6 py-4">
      <button className="text-dark-100 hover:text-dark-text transition-colors p-1">
        <More className="w-6 h-6" color="#EEEEEE" />
      </button>
    </td>
  </tr>
);

const UserFeedbackTableRow = ({ feedback }: { feedback: UserFeedback }) => (
  <tr className="border-b border-dark-30 hover:bg-dark-30 transition-colors">
    <td className="px-6 py-4 text-dark-text font-medium">
      {feedback.feedbackID}
    </td>
    <td className="px-6 py-4 text-dark-text">{feedback.user}</td>
    <td className="px-6 py-4 text-dark-text">{feedback.summary}</td>
    <td className="px-6 py-4 text-dark-text">{feedback.type}</td>
    <td className="px-6 py-4 text-dark-text">{feedback.upvotes}</td>
    <td className="px-6 py-4 text-dark-text">{feedback.dateReported}</td>
    <td className="px-6 py-4">
      <span className="inline-flex px-2 py-1 rounded text-sm text-dark-text">
        {feedback.status}
      </span>
    </td>
    <td className="px-6 py-4">
      <button className="text-dark-100 hover:text-dark-text transition-colors p-1">
        <More className="w-6 h-6" color="#EEEEEE" />
      </button>
    </td>
  </tr>
);

const EmailFeedbackTableRow = ({ feedback }: { feedback: EmailFeedback }) => (
  <tr className="border-b border-dark-30 hover:bg-dark-30 transition-colors">
    <td className="px-6 py-4 text-dark-text font-medium">{feedback.emailID}</td>
    <td className="px-6 py-4 text-dark-text">{feedback.sender}</td>
    <td className="px-6 py-4 text-dark-text">{feedback.subject}</td>
    <td className="px-6 py-4 text-dark-text">{feedback.date}</td>
    <td className="px-6 py-4">
      <span className="inline-flex px-2 py-1 rounded text-sm text-dark-text">
        {feedback.status}
      </span>
    </td>
    <td className="px-6 py-4">
      <button className="text-dark-100 hover:text-dark-text transition-colors p-1">
        <More className="w-6 h-6" color="#EEEEEE" />
      </button>
    </td>
  </tr>
);

const Support = () => {
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div className="max-w-7xl mx-auto space-y-10">
      <PageHeader title="Support & Feedback" />
      <StatsGrid stats={SUPPORT_STATS} columns={2} />

      <DataTable
        title="Support Tickets"
        headers={SUPPORTTICKET_TABLE_HEADERS}
        data={MOCK_SUPPORT_TICKETS}
        renderRow={(ticket) => (
          <SupportTicketTableRow key={ticket.id} ticket={ticket} />
        )}
        filters={
          <>
            <FilterButton label="Category" />
            <FilterButton label="Priority" />
            <FilterButton label="Status" />
            <FilterButton label="Date Range" />
          </>
        }
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />
      <DataTable
        title="User Feedbacks"
        headers={USERFEEDBACK_TABLE_HEADERS}
        data={MOCK_USER_FEEDBACKS}
        renderRow={(feedback) => (
          <UserFeedbackTableRow key={feedback.id} feedback={feedback} />
        )}
        filters={
          <>
            <FilterButton label="Type" />
            <FilterButton label="Status" />
            <FilterButton label="Date Range" />
          </>
        }
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />
      <DataTable
        title="Email Feedbacks"
        headers={EMAILFEEDBACK_TABLE_HEADERS}
        data={MOCK_EMAIL_FEEDBACKS}
        renderRow={(feedback) => (
          <EmailFeedbackTableRow key={feedback.id} feedback={feedback} />
        )}
        filters={
          <>
            <FilterButton label="Status" />
            <FilterButton label="Date Range" />
          </>
        }
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default Support;
